const carouselData = [
  {
    title: '2024国产科幻元年回顾',
    desc: '从《流浪地球2》到《宇宙探索编辑部》，国产科幻电影迎来全面爆发，技术与叙事双双突破。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20cinematic%20scene%2C%20deep%20space%20nebula%20with%20warm%20orange%20and%20golden%20light%2C%20spaceship%20silhouette%2C%20epic%20scale%2C%20dramatic%20atmosphere%2C%20movie%20poster%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=800&height=500&seq=carousel-scifi-01&orientation=landscape',
  },
  {
    title: '悬疑剧天花板：口碑神作盘点',
    desc: '《隐秘的角落》《沉默的真相》《漫长的季节》，国产悬疑剧为何能一部比一部炸裂？',
    tag: '深度盘点',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20rainy%20Chinese%20alley%20at%20night%2C%20wet%20cobblestone%2C%20dim%20streetlamp%20glow%2C%20film%20noir%20lighting%2C%20cinematic%20mood%2C%20dark%20and%20atmospheric%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=800&height=500&seq=carousel-suspense-02&orientation=landscape',
  },
  {
    title: '古装剧服化道进化史',
    desc: '从《甄嬛传》到《长安十二时辰》，国产古装剧的美学标准如何一步步提升到电影级。',
    tag: '文化观察',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20traditional%20costume%20fabric%20details%2C%20silk%20embroidery%20closeup%2C%20ancient%20textile%20patterns%2C%20warm%20candlelight%2C%20rich%20textures%2C%20historical%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=800&height=500&seq=carousel-costume-03&orientation=landscape',
  },
  {
    title: '现实主义电影的社会力量',
    desc: '《我不是药神》《孤注一掷》等作品如何用电影推动社会议题讨论与政策变革。',
    tag: '深度分析',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20style%20Chinese%20urban%20street%20photography%2C%20everyday%20people%20scenes%2C%20warm%20natural%20light%2C%20authentic%20city%20life%2C%20humanistic%20composition%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=800&height=500&seq=carousel-realism-04&orientation=landscape',
  },
  {
    title: '动画电影：国漫崛起之路',
    desc: '《哪吒》《长安三万里》《深海》，中国动画人用十年时间走完了世界百年的技术追赶。',
    tag: '行业观察',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20ink%20wash%20painting%20landscape%2C%20traditional%20ink%20art%20with%20modern%20colors%2C%20misty%20mountains%2C%20flowing%20water%2C%20poetic%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=800&height=500&seq=carousel-anime-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            精选专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            深度解读国产影视行业趋势与佳作，发现不一样的观影视角
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {carouselData.map((item) => (
            <div
              key={item.title}
              className="rounded-lg overflow-hidden bg-background-100 cursor-pointer group"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200 relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="text-[10px] font-medium bg-accent-500 text-background-50 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-xs md:text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-[11px] md:text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}